(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';

    const form = root.closest('form');
    const catalog = JSON.parse(root.querySelector('[data-bundle-catalog]').textContent);
    const offers = [...root.querySelectorAll('input[name^="joias-offer-"]')];
    const selection = root.querySelector('[data-bundle-selection]');
    const slotsElement = root.querySelector('[data-bundle-slots]');
    const status = root.querySelector('[data-bundle-status]');
    const dialog = root.querySelector('[data-bundle-dialog]');
    const productsElement = root.querySelector('[data-bundle-products]');
    const submit = form.querySelector('[name="add"]');
    const picks = Array(5).fill(null);
    let editingIndex = 0;
    let busy = false;

    const selectedQuantity = () => Number(offers.find((offer) => offer.checked).value);
    const activeVariantId = () => Number(form.querySelector('.product-variant-id')?.value);
    const findVariant = (id) => {
      for (const item of catalog) {
        const variant = item.variants.find((entry) => Number(entry.id) === Number(id));
        if (variant) return { item, variant };
      }
      return null;
    };
    const setStatus = (message, error = false) => {
      status.textContent = message;
      status.toggleAttribute('data-error', error);
    };
    function slotButton(index, entry, { fixed = false } = {}) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'joias-botoes-bundle__slot';
      button.disabled = fixed;

      const media = document.createElement('span');
      media.className = 'joias-botoes-bundle__slot-media';
      if (entry) {
        const image = document.createElement('img');
        image.src = entry.variant.image;
        image.alt = '';
        image.loading = 'lazy';
        media.append(image);
      } else {
        const number = document.createElement('span');
        number.className = 'joias-botoes-bundle__slot-number';
        number.textContent = `${index + 1}`;
        media.append(number);
      }
      button.append(media);

      const label = document.createElement('span');
      label.className = 'joias-botoes-bundle__slot-label';
      if (entry) {
        const name = `${entry.item.title}${entry.variant.title === 'Default Title' ? '' : ` · ${entry.variant.title}`}`;
        label.textContent = name;
      } else {
        label.textContent = `Wybierz sztukę ${index + 1}`;
      }
      button.append(label);

      if (!fixed) {
        const edit = document.createElement('span');
        edit.className = 'joias-botoes-bundle__slot-edit';
        edit.textContent = entry ? 'Zmień' : 'Wybierz';
        button.append(edit);
        button.addEventListener('click', () => openChooser(index - 1));
      }
      return button;
    }

    function render() {
      const quantity = selectedQuantity();
      selection.hidden = quantity === 1;
      slotsElement.replaceChildren();
      if (quantity > 1) {
        slotsElement.append(slotButton(0, findVariant(activeVariantId()), { fixed: true }));
        for (let index = 0; index < quantity - 1; index += 1) {
          slotsElement.append(slotButton(index + 1, picks[index] ? findVariant(picks[index]) : null));
        }
        const remaining = picks.slice(0, quantity - 1).filter((id) => !id).length;
        setStatus(remaining
          ? `Wybierz jeszcze ${remaining} ${remaining === 1 ? 'sztukę' : 'sztuki'}.`
          : root.dataset.discountVerified === 'true'
            ? 'Sztuki wybrane. Zniżka potwierdza się w koszyku.'
            : 'Sztuki wybrane. Oferta będzie dostępna po aktywowaniu zniżki.');
      } else {
        setStatus('');
      }
    }

    function renderDialogRows(preferredId) {
      productsElement.replaceChildren();
      catalog.forEach((item) => {
        const row = document.createElement('div');
        row.className = 'joias-botoes-bundle__product';
        const media = document.createElement('div');
        media.className = 'joias-botoes-bundle__product-media';
        const image = document.createElement('img');
        image.className = 'joias-botoes-bundle__product-image';
        image.alt = '';
        media.append(image);

        const details = document.createElement('div');
        details.className = 'joias-botoes-bundle__product-details';
        const info = document.createElement('div');
        info.className = 'joias-botoes-bundle__product-info';
        const title = document.createElement('strong');
        title.className = 'joias-botoes-bundle__product-title';
        title.textContent = item.title;
        const prices = document.createElement('div');
        prices.className = 'joias-botoes-bundle__product-prices';
        const price = document.createElement('span');
        price.className = 'joias-botoes-bundle__product-price';
        const comparePrice = document.createElement('s');
        comparePrice.className = 'joias-botoes-bundle__product-compare-price';
        prices.append(price, comparePrice);
        info.append(title, prices);
        details.append(info);

        let selectedId = preferredId && item.variants.some((variant) => Number(variant.id) === Number(preferredId))
          ? Number(preferredId)
          : item.variants.find((variant) => variant.available)?.id || item.variants[0]?.id;
        const variantButtons = [];

        if (item.variants.length > 1) {
          row.classList.add('joias-botoes-bundle__product--has-variants');
          const variants = document.createElement('div');
          variants.className = 'joias-botoes-bundle__variants';
          variants.setAttribute('role', 'listbox');
          variants.setAttribute('aria-label', `${item.option_name || 'Variantes'} de ${item.title}`);
          item.variants.forEach((variant) => {
            const option = document.createElement('button');
            option.type = 'button';
            option.className = 'joias-botoes-bundle__variant';
            option.setAttribute('role', 'option');
            option.disabled = !variant.available;
            option.title = variant.available ? variant.title : `${variant.title} · Wyprzedane`;
            const photo = document.createElement('img');
            photo.src = variant.image;
            photo.alt = variant.title;
            photo.width = 72;
            photo.height = 72;
            const name = document.createElement('span');
            name.className = 'joias-botoes-bundle__variant-name';
            name.textContent = variant.title;
            option.append(photo, name);
            option.addEventListener('click', () => {
              selectedId = Number(variant.id);
              updateRow();
            });
            variants.append(option);
            variantButtons.push({ id: variant.id, option });
          });
          details.append(variants);
        }

        const choose = document.createElement('button');
        choose.type = 'button';
        choose.className = 'joias-botoes-bundle__choose';
        choose.textContent = 'Wybierz';
        choose.setAttribute('aria-label', `Wybierz ${item.title}`);
        choose.addEventListener('click', () => {
          const variant = item.variants.find((entry) => Number(entry.id) === Number(selectedId));
          if (!variant?.available) return;
          picks[editingIndex] = variant.id;
          dialog.close();
          render();
        });

        function updateRow() {
          const variant = item.variants.find((entry) => Number(entry.id) === Number(selectedId));
          if (!variant) return;
          image.src = variant.image;
          variantButtons.forEach(({ id, option }) => {
            const selected = Number(id) === Number(selectedId);
            option.setAttribute('aria-selected', String(selected));
            option.setAttribute('aria-pressed', String(selected));
          });
          price.textContent = variant.price_formatted;
          comparePrice.textContent = variant.compare_at_price > variant.price
            ? variant.compare_at_price_formatted
            : '';
          comparePrice.hidden = !comparePrice.textContent;
          choose.disabled = !variant.available;
          choose.textContent = variant.available ? 'Wybierz' : 'Wyprzedane';
          choose.setAttribute('aria-label', `${variant.available ? 'Wybierz' : 'Wyprzedane'} ${item.title}${variant.title === 'Default Title' ? '' : `, ${variant.title}`}`);
        }

        row.append(media, details, choose);
        productsElement.append(row);
        updateRow();
      });
      syncChooserMediaSizes();
    }

    function syncChooserMediaSizes() {
      const sizeRows = () => {
        const sampleThumb = productsElement.querySelector('.joias-botoes-bundle__variant img');
        productsElement.querySelectorAll('.joias-botoes-bundle__product').forEach((row) => {
          const media = row.querySelector('.joias-botoes-bundle__product-media');
          const info = row.querySelector('.joias-botoes-bundle__product-info');
          const variantImg = row.querySelector('.joias-botoes-bundle__variant img');
          if (!media || !info) return;
          const gap = Number.parseFloat(getComputedStyle(row).rowGap) || 0;
          const thumbHeight = (variantImg || sampleThumb)?.getBoundingClientRect().height || 64;
          const height = info.getBoundingClientRect().height + gap + thumbHeight;
          row.style.setProperty('--joias-media-size', `${Math.ceil(height)}px`);
        });
      };
      sizeRows();
      requestAnimationFrame(sizeRows);
    }

    function revealIncompleteSelection() {
      setStatus('Wybierz wszystkie sztuki i kolory przed dodaniem do koszyka.', true);
      [...slotsElement.querySelectorAll('.joias-botoes-bundle__slot:not(:disabled)')]
        .filter((slot) => !slot.querySelector('img'))
        .forEach((slot, index) => {
          slot.classList.add('joias-botoes-bundle__slot--needed');
          if (index === 0) slot.focus({ preventScroll: true });
        });
      const header = document.querySelector('sticky-header') || document.querySelector('.header-wrapper');
      const offset = Math.ceil((header?.getBoundingClientRect().bottom || 80) + 16);
      selection.style.scrollMarginTop = `${offset}px`;
      selection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function openChooser(index) {
      if (!catalog.length) {
        setStatus('W tej podglądzie nie ma jeszcze sztuk do wyboru.', true);
        return;
      }
      editingIndex = index;
      renderDialogRows(picks[index]);
      dialog.showModal();
      productsElement.scrollTop = 0;
      syncChooserMediaSizes();
    }

    root.querySelector('[data-bundle-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    offers.forEach((offer) => offer.addEventListener('change', render));
    form.addEventListener('change', (event) => {
      if (event.target.matches('.product-variant-id')) render();
    });

    form.addEventListener('submit', async (event) => {
      const quantity = selectedQuantity();
      if (quantity === 1) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy) return;
      const selected = [activeVariantId(), ...picks.slice(0, quantity - 1)];
      if (selected.some((id) => !id)) {
        revealIncompleteSelection();
        return;
      }
      if (selected.some((id) => !findVariant(id)?.variant.available)) {
        setStatus('Jedna z wybranych sztuk jest już niedostępna. Wybierz inną.', true);
        return;
      }
      if (root.dataset.discountVerified !== 'true') {
        setStatus('Ta oferta czeka na potwierdzenie zniżki w koszyku.', true);
        return;
      }
      busy = true;
      submit.disabled = true;
      setStatus('Dodawanie sztuk…');
      const quantities = new Map();
      selected.forEach((id) => quantities.set(id, (quantities.get(id) || 0) + 1));
      try {
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const sections = cart?.getSectionsToRender?.().map((section) => section.id).filter(Boolean) || [];
        const response = await fetch(root.dataset.cartAddUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [...quantities].map(([id, amount]) => ({ id, quantity: amount })),
            sections,
            sections_url: window.location.pathname
          })
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Nie udało się dodać tych sztuk.');
        }
        if (!cart) {
          window.location.assign(root.dataset.cartUrl);
          return;
        }
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        if (typeof publish === 'function') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'joias-botoes-bundle', cartData: data });
        }
        cart.renderContents(data);
        if (cart.classList?.contains('is-empty')) cart.classList.remove('is-empty');
        setStatus('');
        submit.disabled = false;
        busy = false;
      } catch (error) {
        setStatus(error.message, true);
        submit.disabled = false;
        busy = false;
      }
    }, true);

    render();
  }

  function initAll() {
    document.querySelectorAll('[data-joias-botoes-bundle]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
